export interface User {
  id: number;
  name: string;
  username: string;
  isAdmin: boolean;
}

export const createUser = (
  username: string,
  name: string,
  password: string
) => {
  const option = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      username,
      name,
      password,
    }),
  };
  return fetch("/user", option);
  // TODO: handle username already taken etc.
};
